const SUPPLIER_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE =
  '发票含税金额和订单含税金额需完全一致，请核对发票明细或订单信息'
const DEFAULT_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE =
  '发票含税金额和订单含税金额不一致'
const RED_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE =
  '发票含税金额和订单含税金额差异超0.1元，请核对发票明细或订单信息。'

export function getTotalTaxAmountMismatchMessage(
  pageType: 'BLUE' | 'RED' = 'BLUE',
  routeType?: string,
) {
  if (pageType === 'RED') {
    return RED_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE
  }

  if (routeType === 'supplier') {
    return SUPPLIER_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE
  }

  return DEFAULT_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE
}

export function processCheckCode(item: any) {
  return item?.checkCode ? item.checkCode.slice(-6) : ''
}
const SUPPLIER_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE =
  '发票含税金额和订单含税金额需完全一致，请核对发票明细或订单信息'
const DEFAULT_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE =
  '发票含税金额和订单含税金额不一致'
const RED_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE =
  '发票含税金额和订单含税金额差异超0.1元，请核对发票明细或订单信息。'

export function getTotalTaxAmountMismatchMessage(
  pageType: 'BLUE' | 'RED' = 'BLUE',
  routeType?: string,
) {
  if (pageType === 'RED') {
    return RED_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE
  }

  if (routeType === 'supplier') {
    return SUPPLIER_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE
  }

  return DEFAULT_TOTAL_TAX_AMOUNT_MISMATCH_MESSAGE
}

export function processCheckCode(item: any) {
  return item?.checkCode ? item.checkCode.slice(-6) : ''
}
